import { render, staticRenderFns } from "./SettingsBar.vue?vue&type=template&id=20617eef&scoped=true"
import script from "./SettingsBar.vue?vue&type=script&lang=js"
export * from "./SettingsBar.vue?vue&type=script&lang=js"
import style0 from "./SettingsBar.vue?vue&type=style&index=0&id=20617eef&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20617eef",
  null
  
)

export default component.exports